import FormList from "./FormList";

export default function PdfFormList() {
    return <FormList formType="pdf" />;
}
